<template>
  <van-button
    v-if="boolSmallSize"
    class="ios-upload-small"
    native-type="button"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #icon>
      <em class="iconfont icon-camera"></em>
    </template>
  </van-button>
  <van-button
    v-else
    class="ios-upload"
    native-type="button"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #icon>
      <van-icon name="photograph" />
    </template>
  </van-button>
</template>

<script>
export default {
  name: 'IosUploadIcon',
  props: {
    boolSmallSize: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.ios-upload {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  margin-bottom: 8px;
  background-color: var(--block-bg-light-color);
  border-radius: 6px;
  border: 0;
  &:active::before {
    opacity: 0 !important;
  }

  ::v-deep .van-icon-photograph {
    font-size: 22px;
    color: var(--main-color);
  }

  &.small {
    width: 60px;
    height: 60px;
  }
}

.ios-upload-small {
  border: 0;
  background-color: var(--menu-item-top-bgColor);
  border-radius: 6px;
  color: var(--main-color);
  &:active::before {
    opacity: 0 !important;
  }

  .icon-camera {
    font-size: 20px;
    color: var(--text-color);
  }
}
</style>
